export const MODIFICAR_USER = 'MODIFICAR_USER'
export const PAGO_USER = 'PAGO_USER'

